import { Funder } from './funder';
import { User } from './user';

export class Company {
  company_number!: string;
  company_name!: string;
  industry!: string;
  currency!: string;
  details?: string;
  street_address?: string;
  city?: string;
  country?: string;
  phone_number?: string;
  email?: string;
  bank_name?: string;
  bank_code?: string;
  bank_branch?: string;
  bank_account_name?: string;
  bank_account_number?: string;
  logo_path?: string;
  primary_color!: string;
  tax_certificate_number?: string;
  tax_certificate_exiry_date?: number;
  tax_certificate_path?: string;
  effective_date!: number;
  is_managed_funder!: boolean;
  managed_fund_fee_percentage_per_subscriber!: number;
  managed_fund_fee_amount_per_subscriber!: number;
  managed_fund_fee_percentage_per_claim!: number;
  managed_fund_fee_amount_per_claim_line!: number;
  date_joined?: number;
  date_approved?: number;
  status!: string;
  // Stage 4 PR 5 — Company Lifecycle, 2026-05-13.
  // Signed percentage adjusting every member's invoice line on this
  // company. Positive = loading (surcharge), negative = discount.
  // Set via the Modify Discount or Loading action on company-show-menu.
  discount_or_loading_percentage?: number;
  // Stage 5 PR 57/61, 2026-05-16 — Optional agent group link for
  // company-side commissions. NULL ⇒ no commission generated on
  // this company's contribution receipts.
  agent_group_number?: string;
  date_deleted?: number;
  user_uuid!: string;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  members_count?: number;


  isPendingOrDraft() {
    return this.isDraft() || this.isPending();
  }


  isDraft() {
    return this.status.toLocaleLowerCase() == 'draft';
  }

  isActive() {
    return this.status.toLocaleLowerCase() == 'active';
  }

  isPending() {
    return this.status.toLocaleLowerCase() == 'pending';
  }

  isPendingPayment() {
    return this.status.toLocaleLowerCase() == 'pending_payment';
  }

  isSuspended() {
    return this.status.toLocaleLowerCase() == 'suspended';
  }

  isTerminated() {
    return this.status.toLocaleLowerCase() == 'terminated';
  }

  constructor(data: any) {
    this.company_number = data.company_number;
    this.company_name = data.company_name;
    this.industry = data.industry;
    this.currency = data.currency;
    this.details = data.details;
    this.street_address = data.street_address;
    this.city = data.city;
    this.country = data.country;
    this.phone_number = data.phone_number;
    this.email = data.email;
    this.date_joined = data.date_joined;
    this.bank_name = data.bank_name;
    this.bank_code = data.bank_code;
    this.bank_branch = data.bank_branch;
    this.bank_account_name = data.bank_account_name;
    this.bank_account_number = data.bank_account_number;
    this.logo_path = data.logo_path;
    this.primary_color = data.primary_color;
    this.tax_certificate_number = data.tax_certificate_number;
    this.effective_date = data.effective_date;
    this.tax_certificate_exiry_date = data.tax_certificate_exiry_date;
    this.tax_certificate_path = data.tax_certificate_path;
    this.date_approved = data.date_approved;
    this.is_managed_funder = data.is_managed_funder;
    this.managed_fund_fee_percentage_per_subscriber = data.managed_fund_fee_percentage_per_subscriber;
    this.managed_fund_fee_amount_per_subscriber = data.managed_fund_fee_amount_per_subscriber;
    this.managed_fund_fee_percentage_per_claim = data.managed_fund_fee_percentage_per_claim;
    this.managed_fund_fee_amount_per_claim_line = data.managed_fund_fee_amount_per_claim_line;
    this.status = data.status;
    this.discount_or_loading_percentage = data.discount_or_loading_percentage;
    this.agent_group_number = data.agent_group_number;
    this.date_deleted = data.date_deleted;
    this.user_uuid = data.user_uuid;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    this.members_count = data.members_count;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
